import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GenericModalService } from '../../../../services/generic-modal.service';
import { SystemFlowService } from '../../../../services/configuration/system-flow.service';
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-system-flow-import',
  templateUrl: './system-flow-import.component.html',
  styleUrls: ['./system-flow-import.component.css']
})
export class SystemFlowImportComponent implements OnInit {


  files: File[] = [];
  filesStatus: {message, status}[] = [];
  submitClick = false;
  errorMessage = '';
  @Input() modalTitle: string;
  @Output() itemSaved: Subject<boolean>;

  constructor(
    public bsModalRef: BsModalRef,
    private systemFlowService: SystemFlowService,
    public modalService: GenericModalService
  ) { }

  ngOnInit() {
    this.itemSaved = new Subject();
    this.itemSaved.next(false);
  }

  onImport() {
    this.submitClick = true;
    this.errorMessage = '';
    this.files.forEach( file => {
      this.systemFlowService.importSystemFlow(file)
        .subscribe( response => {
          if (response.type === HttpEventType.UploadProgress) {
            this.filesStatus[this.files.indexOf(file)] = {message: 'Importando...', status: 'uploading'};
            console.log(this.filesStatus);
          }
          if (response.type === HttpEventType.Response) {
            this.filesStatus[this.files.indexOf(file)] = {message: 'Fluxo importado com sucesso', status: 'success'};
            console.log(response);
          }
        }, error1 => {
          if (error1.indexOf('401') !== -1) {
            this.errorMessage = 'Erro: Sessão expirada.';
          } else {
            this.filesStatus[this.files.indexOf(file)] = {message: error1, status: 'error'};
          }
        });
    });
    this.itemSaved.next(true);
  }

  onFileSelected(event) {
    this.errorMessage = '';
    const validExt = event.target.files[0].name.split('.')[1].toUpperCase() === 'SYSTEMFLOW';
    if (validExt) {
      this.files.push(event.target.files[0]);
    } else {
      this.errorMessage = `A extensão do arquivo "${event.target.files[0].name}" não é válida.`;
    }
  }

  removeFromList(item) {
    this.files.splice(this.files.indexOf(item), 1);
  }

  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) { return '0'; }
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  onClose() {
    this.bsModalRef.hide();
  }

}
